import React from 'react'
import Navbar from './Navbar'
import Sidebar from './Sidebar'
import Footer from './Footer'
import CreateTicket from './IA/CreateTicket'

function Areas() {

  return (
    <div>
    <Navbar/>
    <Sidebar />
    <CreateTicket />
    <Footer />
  </div>
  )
}

export default Areas